import { InjectionToken } from '@angular/core';
import { PropertyValidationLookupService } from './types/property-validation-lookup-service.type';

export const REPORT_EDITOR_PROPERTY_VALIDATION_LOOKUP_SERVICE =
  new InjectionToken<PropertyValidationLookupService>(
    'PropertyValidationLookupService',
  );
